<script>
import Lecture from "./components/Lecture.vue";

/* eslint-disable-next-line no-unused-vars*/
const data1 = window.data ?? {
  lecture: {
    Url: "/lectures/intro-part-2/",
    Name: "Intro Part 2",
    VimeoVideo: "63859010",
    CreatedDate: "2011-12-23",
    BodyText:
      "\u003cdiv\u003e\n\u003cp\u003e\u003cstrong\u003eLecture 1-Into to the Comprehensive exam.\u003c/strong\u003e\u003c/p\u003e\n\u003cp\u003eThis lecture has the following goals:\u003c/p\u003e\n\u003col\u003e\n\u003cli\u003eIntroduce the utility, indications, limitations and contraindications of TEE\u003c/li\u003e\n\u003cli\u003eDiscuss the need for a comprehensive TEE exam\u003c/li\u003e\n\u003cli\u003eDiscuss how to perform a comprehensive perioperative TEE exam\u003c/li\u003e\n\u003c/ol\u003e\n\u003cp\u003e \u003c/p\u003e\n\u003c/div\u003e",
    IsPublic: false
  },
  downloads: {
    root: {
      mediaItem: [
        {
          File: {
            "@id": "2386",
            "@version": "8b976490-9184-4736-bd5f-3fa00117340e",
            "@parentID": "2330",
            "@level": "2",
            "@writerID": "1",
            "@nodeType": "1033",
            "@template": "0",
            "@sortOrder": "12",
            "@createDate": "2011-12-14T14:36:02",
            "@updateDate": "2011-12-14T14:36:02",
            "@nodeName": "PDF 15-Indications and Contraindications v4",
            "@urlName": "pdf15-indicationsandcontraindicationsv4",
            "@writerName": "tommy",
            "@nodeTypeAlias": "File",
            "@path": "-1,2330,2386",
            umbracoFile:
              "/media/12929/pdf_15-indications_and_contraindications_v4.pdf",
            umbracoExtension: "pdf",
            umbracoBytes: "125875"
          }
        },
        {
          File: {
            "@id": "2635",
            "@version": "7d2108d3-9328-4dcf-ae30-02d42cbe127d",
            "@parentID": "2330",
            "@level": "2",
            "@writerID": "1",
            "@nodeType": "1033",
            "@template": "0",
            "@sortOrder": "14",
            "@createDate": "2012-02-04T20:08:25",
            "@updateDate": "2012-02-04T20:08:25",
            "@nodeName": "PDF 18- basic TEE",
            "@urlName": "pdf18-basictee",
            "@writerName": "tommy",
            "@nodeTypeAlias": "File",
            "@path": "-1,2330,2635",
            umbracoFile: "/media/15348/pdf_18-_basic_tee.pdf",
            umbracoExtension: "pdf",
            umbracoBytes: "1336503"
          }
        },
        {
          File: {
            "@id": "3318",
            "@version": "a4115e57-0dec-4ad4-86b5-947014ea83b5",
            "@parentID": "2330",
            "@level": "2",
            "@writerID": "1",
            "@nodeType": "1033",
            "@template": "0",
            "@sortOrder": "18",
            "@createDate": "2013-02-02T17:38:46",
            "@updateDate": "2013-02-02T17:38:46",
            "@nodeName": "PDF 21 TEE views with extensive labeling (1)",
            "@urlName": "pdf21teeviewswithextensivelabeling(1)",
            "@writerName": "tommy",
            "@nodeTypeAlias": "File",
            "@path": "-1,2330,3318",
            umbracoFile:
              "/media/41695/pdf_21_tee_views_with_extensive_labeling__1_.pdf",
            umbracoExtension: "pdf",
            umbracoBytes: "503827"
          }
        }
      ]
    }
  }
};

// /* eslint-disable-next-line no-unused-vars*/
// const data2 = {
//   lecture: {
//     Url: "/lectures/the-thoracic-aorta/",
//     Name: "The Thoracic Aorta",
//     VimeoVideo: "63972431",
//     CreatedDate: "2011-08-27",
//     BodyText:
//       "\u003cp\u003eThis lecture discusses the echocardiographic evaluation of the thoracic aorta.\u003c/p\u003e",
//     IsPublic: false
//   },
//   downloads: {
//     root: {
//       mediaItem: {
//         File: {
//           "@id": "2371",
//           "@version": "75be960d-44ef-4fdb-a386-541d614808ce",
//           "@parentID": "2330",
//           "@level": "2",
//           "@writerID": "1",
//           "@nodeType": "1033",
//           "@template": "0",
//           "@sortOrder": "8",
//           "@createDate": "2011-12-03T20:26:18",
//           "@updateDate": "2011-12-03T20:26:18",
//           "@nodeName": "PDF 10-Dissection discussion-8-25-11- v4",
//           "@urlName": "pdf10-dissectiondiscussion-8-25-11-v4",
//           "@writerName": "tommy",
//           "@nodeTypeAlias": "File",
//           "@path": "-1,2330,2371",
//           umbracoFile:
//             "/media/12684/pdf_10-dissection_discussion-8-25-11-_v4.pdf",
//           umbracoExtension: "pdf",
//           umbracoBytes: "332266"
//         }
//       }
//     }
//   }
// };

const data = data1;

export default {
  name: "App",
  components: {
    Lecture
  },
  data() {
    return {
      lecture: data.lecture,
      downloads: data.downloads
    };
  }
};
</script>
<template>
  <div id="app" :class="$style.app">
    <Lecture :lecture="lecture" :downloads="downloads" />
  </div>
</template>

<style lang="scss" module>
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
